// Qué entra a la tabla de venta rápida y cuándo quedan las últimas piezas. La búsqueda y el orden
// viven en `pos/lib/posCatalog.ts`.
import type { CatalogItem } from '@/domains/sales/wizard/types';
import { isService } from '@/domains/sales/wizard/catalogAvailability';
import { isPhoneFree } from '@/domains/sales/wizard/productSuggestions';
import { availableOf } from '../../pos/lib/posCatalog';

/** Hasta cuántas piezas cuenta como «Últimas piezas». */
export const LAST_ACCESSORIES_MAX = 3;

/** Todo lo que no es teléfono ni lo trae: accesorios, servicios, SIM, módems y kits sin teléfono. */
export function quickSaleItemsOf(items: readonly CatalogItem[]): CatalogItem[] {
    return items.filter((item) => isPhoneFree(item, items));
}

export function isLastAccessories(item: Pick<CatalogItem, 'itemType' | 'stock'>): boolean {
    if (isService(item)) return false;
    const available = availableOf(item);
    return available > 0 && available <= LAST_ACCESSORIES_MAX;
}
